export enum OneClickPreviewField {
  Jobsite = 'jobsite',
  PointOfDelivery = 'pointOfDelivery',
  Product = 'product',
  Contract = 'contract',
  Quantity = 'quantity',
  Unit = 'unit',
  Payment = 'payment',
  Plant = 'plant',
  StandardLot = 'standardLot',
  DeliveryMethod = 'deliveryMethod',
  Time = 'time',
  ReceivingPerson = 'receivingPerson',
  ReceivingPersonPhone = 'receivingPersonPhone',
  ReceivingPersonName = 'receivingPersonName',
  ReceivingPersonCreateANewOne = 'receivingPersonCreateANewOne',
  ReceivingPersonCancel = 'receivingPersonCancel',
  TimeWindow = 'timeWindow',
  DeliveryDate = 'deliveryDate',
  PurchaseOrder = 'purchaseOrder',
  Prices = 'prices',
  AdditionalServices = 'additionalServices',
  Hauler = 'hauler',
  Vehicle = 'vehicle',
  OwnFreightDate = 'ownFreightDate',
  SpecialInstructions = 'specialInstructions',
}
